import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { CommonConfigService } from '../../../../utils/common-config';
import { IMaskModule } from 'angular-imask';
import { CurrencyPipe } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'role-base',
    standalone: true,
    imports: [ButtonModule, TabsModule, DialogModule, InputTextModule, FormsModule, TableModule, NgIf, NgFor, NgClass, IMaskModule, CurrencyPipe],
    templateUrl: './role-base.component.html',
    styleUrl: './role-base.component.less',
})
export class RoleBaseComponent implements OnInit {
    constructor(
        private http: HttpClient,
        private commonConfigService: CommonConfigService,
        private router: Router
    ) {}
    addRoleDialogVisible: boolean = false;
    deleteRoleDialogVisible: boolean = false;
    roleName: string = '';
    roles: any[] = [];
    currentRoleIndex!: number;
    currentRoleName!: string;
    CNYMask = {};
    originRoles: any[] = [];
    showRoleNameErrorMsg: boolean = false;
    saveRoleFailedDialogVisible: boolean = false;
    validateRoleBaseFailedDialogVisible: boolean = false;

    ngOnInit() {
        this.CNYMask = this.commonConfigService.getCNYMaskConfig();
        this.getRoles();
    }

    showAddRoleDialog() {
        this.addRoleDialogVisible = true;
    }
    closeAddRoleDialog(action: string) {
        if (action == 'save') {
            if (!this.roleName.trim()) {
                this.showRoleNameErrorMsg = true;
                return;
            }
            this.roles.push({
                roleName: this.roleName,
                action: 'edit',
                type: 'new',
                data: [
                    {
                        base: 'Min Base (CNY)',
                        1: '',
                        2: '',
                        3: '',
                        4: '',
                        5: '',
                        6: '',
                    },
                    {
                        base: 'Max Base (CNY)',
                        1: '',
                        2: '',
                        3: '',
                        4: '',
                        5: '',
                        6: '',
                    },
                ],
            });
        }
        this.addRoleDialogVisible = false;
        this.showRoleNameErrorMsg = false;
        this.roleName = '';
    }
    handleDeleteRole(index: number) {
        this.deleteRoleDialogVisible = true;
        this.currentRoleIndex = index;
        this.currentRoleName = this.roles[index].roleName;
    }

    handleDiscardChangesForRole(index: number) {
        if (this.roles[index].type == 'new') {
            this.deleteRoleDialogVisible = true;
            this.currentRoleIndex = index;
            this.currentRoleName = this.roles[index].roleName;
        } else {
            for (let i = 0; i < this.originRoles.length; i++) {
                if (this.originRoles[i].id == this.roles[index].id) {
                    this.roles[index] = JSON.parse(JSON.stringify(this.originRoles[i]));
                    this.roles[index].action = 'view';
                }
            }
        }
    }

    handleEditRole(index: number) {
        this.roles[index].action = 'edit';
    }
    handleSaveRole(index: number) {
        let validationResult = this.validationRoleBase(this.roles[index].data);
        if (!validationResult) {
            this.validateRoleBaseFailedDialogVisible = true;
            return;
        }
        let params: any = {
            roleName: this.roles[index].roleName,
            costBases: this.getCostBases(this.roles[index].data),
        };
        if (this.roles[index].id) {
            params.id = this.roles[index].id;
        }
        this.http
            .post(`${environment.apiUrl}/Configure/Role`, params, {
                withCredentials: true,
            })
            .subscribe({
                next: (res: any) => {
                    this.getRoles();
                },
                error: (err) => {
                    if (err.status === 401) {
                        this.router.navigate(['/configuration/sign-in']);
                    } else {
                        this.saveRoleFailedDialogVisible = true;
                    }
                },
            });
    }
    closeDeleteRoleDialog(action: string) {
        this.deleteRoleDialogVisible = false;
        if (action == 'delete') {
            if (this.roles[this.currentRoleIndex].type == 'new') {
                this.roles.splice(this.currentRoleIndex, 1);
            } else {
                let id = this.roles[this.currentRoleIndex].id;
                this.http
                    .post(`${environment.apiUrl}/Configure/role/${id}/delete`, {
                        withCredentials: true,
                    })
                    .subscribe({
                        next: (res: any) => {
                            this.getRoles();
                        },
                        error: (err) => {
                            if (err.status === 401) {
                                this.router.navigate(['/configuration/sign-in']);
                            }
                        },
                    });
            }
        }
    }
    getCostBases(data: any[]) {
        let result = [];
        for (let i = 1; i < 7; i++) {
            result.push({
                level: i,
                minBase: this.commonConfigService.formatAmountInput(data[0][i]),
                maxBase: this.commonConfigService.formatAmountInput(data[1][i]),
            });
        }
        return result;
    }
    getRoles() {
        this.http
            .get(`${environment.apiUrl}/Configure/roles`, {
                withCredentials: true,
                observe: 'response',
            })
            .subscribe({
                next: (res: HttpResponse<any>) => {
                    this.roles = [];
                    if (res.body?.length) {
                        for (let i = 0; i < res.body.length; i++) {
                            let role = res.body[i];
                            let data: any = [
                                {
                                    base: 'Min Base (CNY)',
                                    1: '',
                                    2: '',
                                    3: '',
                                    4: '',
                                    5: '',
                                    6: '',
                                },
                                {
                                    base: 'Max Base (CNY)',
                                    1: '',
                                    2: '',
                                    3: '',
                                    4: '',
                                    5: '',
                                    6: '',
                                },
                            ];
                            for (let j = 0; j < role.costBases.length; j++) {
                                let level = role.costBases[j].level;
                                data[0][level] = role.costBases[j].minBase.toString();
                                data[1][level] = role.costBases[j].maxBase.toString();
                            }
                            this.roles.push({
                                roleName: res.body[i].roleName,
                                id: res.body[i].id,
                                action: 'view',
                                type: 'existed',
                                data: data,
                            });
                        }
                        this.originRoles = JSON.parse(JSON.stringify(this.roles));
                    }
                },
                error: (err) => {
                    if (err.status === 401) {
                        this.router.navigate(['/configuration/sign-in']);
                    }
                },
            });
    }

    closeSaveRoleFailedDialog() {
        this.saveRoleFailedDialogVisible = false;
    }

    validationRoleBase(baseData: any) {
        let isValid = true;
        for (let i = 1; i <= 6; i++) {
            if (parseFloat(baseData[0][i].replace(/[¥,]/g, '')) >= parseFloat(baseData[1][i].replace(/[¥,]/g, ''))) {
                isValid = false;
                break;
            }
        }
        return isValid;
    }

    closeValidateRoleBaseFailedDialog() {
        this.validateRoleBaseFailedDialogVisible = false;
    }
}
